import { render, staticRenderFns } from "./PaymentMethodsPage.vue?vue&type=template&id=1eff7450&scoped=true"
import script from "./PaymentMethodsPage.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodsPage.vue?vue&type=style&index=0&id=1eff7450&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff7450",
  null
  
)

export default component.exports